'use strict';

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    wrap: {
      display: 'flex'
    },
    icon: {
      '& .fill': {
        fill: theme.icon.color
      },
      '& .stroke': {
        stroke: theme.icon.color
      },
      '&.error': {
        '& .fill': {
          fill: theme.errorColor
        },
        '& .stroke': {
          stroke: theme.errorColor
        }
      },
      '&.disabled': {
        opacity: theme.disabledOpacity
      },
      '&.hidden': {
        display: 'none'
      }
    },
    micro: {
      width: theme.icon.micro,
      height: theme.icon.micro
    },
    small: {
      width: theme.icon.small,
      height: theme.icon.small
    },
    medium: {
      width: theme.icon.medium,
      height: theme.icon.medium
    },
    large: {
      width: theme.icon.large,
      height: theme.icon.large
    },
    xlarge: {
      width: theme.icon.xlarge,
      height: theme.icon.xlarge
    }
  };
};